import React from 'react';

function SustainableGamesPage() {
    const games = [
        { id: 'collector', name: 'Computer Collector', src: '/sustainable-snake-game.html', available: true },
        { id: 'recycler', name: 'Circuit Recycler', available: false },
        { id: 'optimizer', name: 'Energy Optimizer', available: false },
        { id: 'botanist', name: 'Green Botanist', available: false }
    ];

    return (
        <div className="min-h-screen bg-gray-100 dark:bg-gray-900 p-8">
            <h1 className="text-3xl font-bold text-gray-900 dark:text-gray-100 mb-6 text-center">Sustainable Games</h1>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                {games.map((game) => (
                    <div key={game.id} className="bg-white dark:bg-gray-800 shadow rounded-lg overflow-hidden">
                        <div className="p-4">
                            <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-2">{game.name}</h2>
                            {game.available ? (
                                <iframe
                                    src={game.src}
                                    className="w-full h-64"
                                    title={game.name}
                                    sandbox="allow-scripts allow-same-origin"
                                />
                            ) : (
                                <div className="h-64 flex items-center justify-center bg-gray-200 dark:bg-gray-700 text-gray-500">
                                    Coming Soon
                                </div>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default SustainableGamesPage;
